import React from "react";
import ReactDOM from "react-dom/client";

import AppRouter from "./approuter";
// import * as serviceWorker from './client/serviceWorker';

// boostrap
import "bootstrap/dist/css/bootstrap.min.css";
//fontawesome

import "react-image-lightbox/style.css";
import "react-datepicker/dist/react-datepicker.css";
//carousel
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import "bootstrap/dist/css/bootstrap.min.css";

if (window.location.pathname.includes("admin")) {
  require("./admin/assets/css/feathericon.min.css");
  require("./admin/assets/js/feather.min.js");
  require("./admin/assets/plugins/fontawesome/css/fontawesome.min.css");
  require("./admin/assets/plugins/fontawesome/css/all.min.css");
  require("./admin/assets/plugins/fontawesome/js/fontawesome.min.js");
  require("./admin/assets/css/font-awesome.min.css");
  require("./admin/assets/css/custom.css");
}

// document.addEventListener('contextmenu', (e) => e.preventDefault());

// Only block DevTools in production
if (process.env.NODE_ENV === 'production') {
  document.onkeydown = function (e) {
    if (e.keyCode === 123) {
      return false;
    }
    if (e.ctrlKey && e.shiftKey && e.keyCode === "I".charCodeAt(0)) {
      return false;
    }
    if (e.ctrlKey && e.shiftKey && e.keyCode === "C".charCodeAt(0)) {
      return false;
    }
    if (e.ctrlKey && e.shiftKey && e.keyCode === "J".charCodeAt(0)) {
      return false;
    }
    if (e.ctrlKey && e.keyCode === "U".charCodeAt(0)) {
      return false;
    }
  };
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <>
    <AppRouter />
  </>
);
